import React from 'react';
import ZoomInIcon from '../../images/Icon20_ZoomIn.svg';
import ZoomOutIcon from '../../images/Icon20_ZoomOut.svg';
import FitIcon from '../../images/Icon20_ZoomFitScreen.svg';
import styles from './DualViewerToolbar.scss';
import Button from './Button';
import { __ } from '../../../../core/utils';

const DualViewerToolbar = ({ v1, v2 }) => {
  return (
    <div className={styles.OSDToolbar}>
      {[
        {
          id: 'zoomIn',
          icon: ZoomInIcon,
          extraClass: ['roundedUp'],
          onClick: () => {
            v1.viewport.zoomBy(1.2);
            v1.viewport.applyConstraints();

            v2.viewport.zoomBy(1.2);
            v2.viewport.applyConstraints();
          },
        },
        {
          id: 'zoomOut',
          icon: ZoomOutIcon,
          onClick: () => {
            v1.viewport.zoomBy(0.8);
            v1.viewport.applyConstraints();

            v2.viewport.zoomBy(0.8);
            v2.viewport.applyConstraints();
          },
        },
        {
          id: 'fit',
          icon: FitIcon,
          onClick: () => {
            v1.viewport.goHome();
            v2.viewport.goHome();
          },
        },
      ].map(({ id, icon, onClick, extraClass }) => (
        <Button
          key={id}
          id={id}
          icon={icon}
          onClick={onClick}
          extraClass={[extraClass]}
          label={__('canvas.toolbar.' + id)}
        />
      ))}
    </div>
  );
};

export default DualViewerToolbar;
